import React from "react";
import { Button } from "@mui/material";
import {
  FruitifyStack,
  RegistrationCard,
} from "../../../../shared-components/Containers";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function PaymentError({ onRetry }) {
  return (
    <FruitifyStack>
      <RegistrationCard variant={"outlined"}>
        <Stack direction={"column"} alignItems={"center"} textAlign={"center"}>
          <ErrorOutlineIcon sx={{ fontSize: 120 }} />
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
          >
            Payment error
          </Typography>
        </Stack>

        <Typography variant="subtitle1" sx={{ width: "100%" }}>
          There has been an error with your payment. Please try again.
        </Typography>
        <Button variant={"contained"} onClick={onRetry}>
          Try Again
        </Button>
      </RegistrationCard>
    </FruitifyStack>
  );
}
